import React from "react"
import ReactDOM from "react-dom/client"
import {App} from "./App"
import reportWebVitals from "./reportWebVitals"
import {BrowserRouter} from "react-router-dom"
import {HelmetProvider} from "react-helmet-async"
import {Provider} from "react-redux"
import {store} from "./store/store"
import {ConfigProvider} from "antd"
import ruRU from "antd/locale/ru_RU"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
)
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <HelmetProvider>
                <ConfigProvider locale={ruRU}>
                    <App/>
                </ConfigProvider>
            </HelmetProvider>
        </BrowserRouter>
    </Provider>,
    // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
